import { MESSAGE_CLEAR, MESSAGE_SET } from 'constants/actions';

import { dispatcher } from 'lib/redux';

export const clearMessage = () => () => {
  dispatcher(MESSAGE_CLEAR);
};

export const setMessage = (message, type) => () => {
  dispatcher(MESSAGE_SET, { message, type });
};

export const dispatchSetMessage = (message, type) => {
  dispatcher(MESSAGE_SET, { message, type });
};
